import ApiService from "@/core/services/ApiService";
import {Actions, Mutations} from "@/store/enums/StoreEnums";
import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";

@Module
export default class StockModule extends VuexModule {
    errors = [];

    @Mutation
    [Mutations.SET_ERROR](error) {
        this.errors = error;
    }

    @Action
    [Actions.STOCKS_LIST](payload) {
        return new Promise<void>((resolve, reject) => {
            ApiService.setHeader()
            ApiService.get("/stock/list", payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                    reject();
                });
        });
    }

    @Action
    [Actions.ADD_STOCK](payload) {
        return new Promise<void>((resolve, reject) => {
            ApiService.setHeader()
            ApiService.post("/stock/create", payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                    reject();
                });
        });
    }

    @Action
    [Actions.UPDATE_STOCK](payload) {
        ApiService.setHeader();
        return new Promise<void>((resolve, reject) => {
            ApiService.put("/stock/update", payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                    reject();
                });
        });
    }

    @Action
    [Actions.STOCK_DELETE](payload) {
        return new Promise<void>((resolve, reject) => {
            ApiService.setHeader()
            ApiService.delete("/stock/delete/" + payload)
                .then(({data}) => resolve(data))
                .catch(({response}) => {
                    this.context.commit(Mutations.SET_ERROR, response.data.errors);
                    reject();
                });
        });
    }
}
